document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for all elements to be fully loaded
  setTimeout(function() {
    const sizeButtons = document.querySelectorAll('.size-option-button');
    
    // Get product data
    const productDataElement = document.querySelector('#product-data');
    let productData = null;
    if (productDataElement && productDataElement.dataset.product) {
      try {
        productData = JSON.parse(productDataElement.dataset.product);
      } catch (e) {
        console.error('Error parsing product data:', e);
      }
    }
    
    // Helper function to convert text to handle format (like Shopify's handle filter)
    function toHandle(text) {
      return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    
    sizeButtons.forEach(button => {
      // Skip unavailable variants - don't add event listeners
      if (button.classList.contains('unavailable-variant') || button.hasAttribute('data-unavailable')) {
        return;
      }
      
      // Add hover effects
      button.addEventListener('mouseenter', function() {
        if (!this.classList.contains('selected') && !this.classList.contains('unavailable-variant')) {
          this.style.borderColor = '#666';
          this.style.backgroundColor = '#f5f5f5';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        if (!this.classList.contains('selected') && !this.classList.contains('unavailable-variant')) {
          this.style.borderColor = '#ddd';
          this.style.backgroundColor = '#fff';
        }
      });
      
      // Handle selection
      button.addEventListener('click', function(e) {
        // Prevent clicks on unavailable variants
        if (this.classList.contains('unavailable-variant') || this.hasAttribute('data-unavailable')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        
        e.preventDefault();
        
        // Find the parent fieldset to scope the selection
        const parentFieldset = this.closest('fieldset');
        if (!parentFieldset) return;
        
        // Remove selected class from all buttons in THIS fieldset only
        const siblingButtons = parentFieldset.querySelectorAll('.size-option-button');
        siblingButtons.forEach(btn => {
          btn.classList.remove('selected');
          btn.style.backgroundColor = '#fff';
          btn.style.color = '#333';
          btn.style.borderColor = '#ddd';
        });
        
        // Add selected class to clicked button
        this.classList.add('selected');
        this.style.backgroundColor = '#000';
        this.style.color = '#fff';
        this.style.borderColor = '#000';
        
        // Update the hidden select in the same fieldset
        const hiddenSelect = parentFieldset.querySelector('[data-node-type="add-to-cart-option-select"]');
        if (hiddenSelect) {
          const buttonText = this.textContent.trim();
          const buttonHandle = toHandle(buttonText);
          
          // Find matching option by handle value (which is what product-options.liquid uses)
          const options = hiddenSelect.querySelectorAll('option');
          let optionFound = false;
          
          options.forEach(option => {
            if (option.value === buttonHandle) {
              hiddenSelect.value = option.value;
              optionFound = true;
            }
          });
          
          // Fallback: try exact text match
          if (!optionFound) {
            options.forEach(option => {
              if (option.textContent.trim().toLowerCase() === buttonText.toLowerCase()) {
                hiddenSelect.value = option.value;
                optionFound = true;
              }
            });
          }
          
          // Trigger change event
          hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Also trigger input event for better compatibility
          hiddenSelect.dispatchEvent(new Event('input', { bubbles: true }));
        }
        
        // Update variant ID based on selected options
        updateVariantId();
      });
    });
    
    // Function to update variant ID
    function updateVariantId() {
      if (!productData || !productData.variants) return;
      
      const form = document.querySelector('[data-node-type="commerce-add-to-cart-form"]');
      if (!form) return;
      
      // Get all selected options (as display text, not handles)
      const selectedOptions = [];
      const selects = form.querySelectorAll('[data-node-type="add-to-cart-option-select"]');
      
      selects.forEach(select => {
        if (select.value) {
          // Get the display text from the selected option
          const selectedOption = select.querySelector(`option[value="${select.value}"]`);
          if (selectedOption) {
            selectedOptions.push(selectedOption.textContent.trim());
          }
        }
      });
      
      // Find matching variant
      let matchingVariant = null;
      
      if (selectedOptions.length > 0) {
        matchingVariant = productData.variants.find(variant => {
          return variant.options.every((option, index) => {
            return option.toLowerCase() === selectedOptions[index]?.toLowerCase();
          });
        });
      }
      
      // Fallback to first available variant
      if (!matchingVariant) {
        matchingVariant = productData.variants.find(variant => variant.available) || productData.variants[0];
      }
      
      // Update hidden input
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && matchingVariant) {
        variantInput.value = matchingVariant.id;
      }
    }
    
    // Auto-select first available option in each group
    const fieldsets = document.querySelectorAll('fieldset[data-node-type="add-to-cart-option"]');
    fieldsets.forEach(fieldset => {
      const availableButtons = fieldset.querySelectorAll('.size-option-button:not(.unavailable-variant):not([data-unavailable])');
      if (availableButtons.length > 0) {
        availableButtons[0].click();
      } else {
        // Fallback: if all are unavailable, select first one anyway (for display purposes)
        const firstButton = fieldset.querySelector('.size-option-button:first-child');
        if (firstButton) {
          firstButton.click();
        }
      }
    });
    
    // Initial variant ID update
    updateVariantId();
    
  }, 100); // Small delay to ensure DOM is ready
}); 